import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingScreen from "../ui/loadingScreen/LoadingScreen";

export default function SuperAdminRoute() {
  const { auth, loading } = useAuth();

  if (loading) return <LoadingScreen mainText="Cargando sesión..." />;
  if (!auth) return <Navigate to="/login" replace />;
  if (!auth.user?.is_account_admin) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
